<div class="confirm-panel w-100 p-3 pt-1">
  <div class="d-flex justify-content-between align-items-center">
    <span class="text-dark fw-semibold">{{ title }}</span>
    <div class="btn-confirm-box p-1 pe-0">
      <button class="btn btn-sm btn-confirm btn-outline-yes rounded-1 disabled">
        <i class="bi bi-check align-middle"></i><span class="">yes</span>
      </button>
      <button class="btn btn-sm btn-confirm btn-outline-no rounded-1 me-1 disabled">
        <i class="bi bi-x align-middle"></i><span class="">no</span>
      </button>
    </div>
  </div>
  <ng-content></ng-content>
</div>
